@if (effectiveCount() >= 3) {
  <umss-card
    variant="Default"
    padding="Regular"
    borderRadius="Regular"
    [hoverable]="true"
    class="citation-action-card"
  >
    <div class="citation-action-content">
      <div class="citation-action-icon">
        <umss-icon
          name="phosphorWarningBold"
          size="24px"
          color="var(--red-500)"
        ></umss-icon>
      </div>

      <div class="citation-action-details">
        <span class="citation-action-title red">
          You are under probation. You have
          {{ effectiveCount() }} pending offenses.
        </span>
      </div>

      @if (showRedirectButton()) {
        <umss-button
          label="Expand details"
          variant="Destructive"
          size="Regular"
          (onClick)="onClickExpandDetails()"
        />
      }
    </div>
  </umss-card>
}
